export class CarRiskData {
    makeKey: string;
    modelKey: string;
    versionKey: string;
    isImported: boolean;
    category: string;
    statedAmount: number;
    referencePrice0km: number;
    hasGnc: boolean;
    is0km: boolean;
    fuelCode: string;
    year: number;
    accessoriesStatedAmount: number;
    infoAutoCode: number;
    carDescription: string;
    gncRegulatorStatedAmount: number;
    gncStatedAmount: number;
}
